'use client';

import { c as _c } from "react/compiler-runtime";
import { getImageProxyUrl, isCDNPath, isPublicStaticPath } from '@/shared/lib/proxy-url';
import Image, { type ImageProps } from 'next/image';
type Props = Omit<ImageProps, 'loader'> & {
  src: string;
  useLoader?: boolean;
  thumbnailSize?: 'small' | 'medium' | 'large';
};
export const ProxyImage = t0 => {
  const $ = _c(22);
  let props;
  let sizes;
  let src;
  let t1;
  let t2;
  let t3;
  let t4;
  let unoptimized;
  if ($[0] !== t0) {
    ({
      src,
      alt: t1,
      sizes,
      useLoader: t2,
      thumbnailSize: t3,
      draggable: t4,
      unoptimized,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = sizes;
    $[3] = src;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = unoptimized;
  } else {
    props = $[1];
    sizes = $[2];
    src = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    unoptimized = $[8];
  }
  const alt = t1 === undefined ? "" : t1;
  const useLoader = t2 === undefined ? true : t2;
  const thumbnailSize = t3 === undefined ? "small" : t3;
  const draggable = t4 === undefined ? false : t4;
  let t5;
  if ($[9] !== src) {
    t5 = isPublicStaticPath(src) && !isCDNPath(src);
    $[9] = src;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const isStaticPath = t5;
  const shouldSkipOptimization = unoptimized ?? isStaticPath;
  const shouldUseLoader = useLoader && !isStaticPath;
  let t6;
  if ($[11] !== shouldUseLoader || $[12] !== thumbnailSize) {
    t6 = shouldUseLoader ? loaderProps => getImageProxyUrl({
      ...loaderProps,
      thumbnailSize
    }) : undefined;
    $[11] = shouldUseLoader;
    $[12] = thumbnailSize;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = sizes ?? "(max-width: 768px) 100vw, 33vw";
  let t8;
  if ($[14] !== alt || $[15] !== draggable || $[16] !== props || $[17] !== shouldSkipOptimization || $[18] !== src || $[19] !== t6 || $[20] !== t7) {
    t8 = <Image {...props} alt={alt} draggable={draggable} src={src} unoptimized={shouldSkipOptimization} loader={t6} sizes={t7} />;
    $[14] = alt;
    $[15] = draggable;
    $[16] = props;
    $[17] = shouldSkipOptimization;
    $[18] = src;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
ProxyImage.displayName = 'ProxyImage';